import React from "react";
import { ShieldCheck, Sparkles, Smile, Heart, Star, User } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
const services = [{
  title: "Hollywood Smile",
  description: "Estetik ve fonksiyonun mükemmel uyumuyla, size özel tasarlanmış ışıltılı ve doğal bir gülüşe kavuşmanız için sanatsal dokunuşlar yapıyoruz.",
  icon: Sparkles
}, {
  title: "İmplant Tedavisi",
  description: "Eksik dişlerin yerini alan ileri teknoloji çözümlerle, ömür boyu sürecek güvenli, fonksiyonel ve estetik bir gülümseme sunuyoruz.",
  icon: ShieldCheck
}, {
  title: "Diş Beyazlatma (Bleaching)",
  description: "Modern ve hassas yöntemlerle dişlerinizin doğal beyazlığını ortaya çıkarıyor, ışıltınızı en güvenli şekilde geri kazandırıyoruz.",
  icon: Smile
}, {
  title: "Laminate Veneers\xA0 (Yaprak Porselen)",
  description: "Dişlerin ön yüzeyine uygulanan ultra ince porselen yapraklar ile minimum müdahale ve maksimum estetikle doğal bir gülümseme tasarlıyoruz.",
  icon: Heart
}, {
  title: "Şeffaf Plak Tedavisi",
  description: "Geleneksel tellere estetik bir alternatif sunan şeffaf plaklarla, dişlerinizi neredeyse görünmez ve konforlu bir şekilde hizalıyoruz.",
  icon: Star
}, {
  title: "Zirkonyum Kaplama",
  description: "Metal desteksiz, yüksek ışık geçirgenliğine sahip zirkonyum restorasyonlarla hem dayanıklı hem de biyouyumlu estetik sonuçlar elde ediyoruz.",
  icon: User
}];
export default function OurExpertise() {
  return <section data-section-id="194384" id="uzmanlık-alanlarımız" className="bg-background text-foreground">
      <div className="bg-secondary/30 w-full py-20 md:py-28 lg:py-32">
        <div className="container mx-auto px-6 md:px-8 max-w-7xl">
          <div className="mb-16 md:mb-24 border-l border-primary/40 pl-6 md:pl-8">
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl text-foreground font-light tracking-tight">
              Uzmanlık Alanlarımız
            </h2>
            <p className="mt-6 text-muted-foreground font-sans text-lg md:text-xl max-w-2xl leading-relaxed tracking-wide">
              Diş Hekimi Ayşegül İnneci Uzun Kliniği'nde, yüksek estetik standartları ve modern tıbbın imkanlarını birleştirerek size seçkin bir tedavi deneyimi sunuyoruz.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12">
            {services.map((service, i) => {
            const Icon = service.icon;
            return <Card key={i} data-index={i} className="border-none bg-card shadow-sm hover:shadow-xl transition-all duration-700 hover:-translate-y-2 group h-full flex flex-col rounded-sm">
                  <CardHeader className="px-8 pt-12 pb-4">
                    <Icon className="w-10 h-10 text-primary stroke-[1] mb-8 transition-transform duration-700 group-hover:scale-110" />
                    <CardTitle className="font-serif text-2xl md:text-3xl text-foreground font-normal tracking-tight">
                      {service.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="px-8 pb-12 pt-0 flex-grow">
                    <CardDescription className="font-sans text-base text-muted-foreground leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardContent>
                </Card>;
          })}
          </div>
        </div>
      </div>
    </section>;
}